import React from 'react'

import { Route, Switch } from 'react-router-dom'

import { Location } from 'history'

import { AppBranding } from '@percept/types'

import { OAuthInvitationLanding } from './OAuthInvitationLanding'
import { OAuthCallback } from './OAuthCallback'
import { OAuthLayout } from './OAuthLayout'
import { OAuthPublicErrorBoundary } from './OAuthPublicErrorBoundary'


/* Returns true when the supplied location should be handled by the public
 * OAuth-invitation flow (recipient-facing magic-link landing or provider
 * callback). Consumers should branch on this BEFORE their usual
 * auth/route-gated rendering so unauthenticated recipients don't get
 * redirected to a sign-in page. */
export const isOAuthInvitationPublicLocation = ({ pathname }: Location): boolean => (
  pathname.startsWith('/oauth-invitation/')
  || pathname.startsWith('/oauth-callback')
)


export type OAuthPublicRoutesProps = {
  /* Forwarded to both Landing and Callback. Multi-tenant apps wire this to
   * their theme switcher; single-tenant apps omit it (theme stays locked). */
  onBrandingResolved?: (branding: AppBranding) => void
}


export const OAuthPublicRoutes = ({
  onBrandingResolved,
}: OAuthPublicRoutesProps): JSX.Element => (
  <OAuthPublicErrorBoundary>
    <OAuthLayout>
      <Switch>
        <Route
          path='/oauth-invitation/:token'
          render={(): JSX.Element => (
            <OAuthInvitationLanding onBrandingResolved={onBrandingResolved} />
          )} />
        <Route
          path='/oauth-callback'
          render={(): JSX.Element => (
            <OAuthCallback onBrandingResolved={onBrandingResolved} />
          )} />
      </Switch>
    </OAuthLayout>
  </OAuthPublicErrorBoundary>
)
